import React, { useEffect, useState } from "react";
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { logOut } from "../../helpers/configRoutes/backend_helper";

const Header = () => {
    const navigate = useNavigate();
    const user = useSelector((state) => state.Login.user);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
    const location = useLocation();

    // Close profile menu on route change
    useEffect(() => {
        setIsProfileMenuOpen(false);
    }, [location]);

    const toggleProfileMenu = () => {
        setIsProfileMenuOpen(prev => !prev);
    };

    const handleLogout = async () => {
        try {
            await logOut();
        } catch (e) {
            // opcional: manejar error silencioso
        }
        localStorage.removeItem('isAuth');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        navigate('/login');
    };

    return (
        <header className="
  w-full h-16 px-4 lg:px-6 flex items-center justify-between
  bg-gradient-to-r from-cs-primary-dark to-cs-primary
  shadow-md border-b border-cs-primary/30
">
            <div className="flex items-center gap-3">
                <Link to="/" className="flex items-center gap-2">
                    <img src="/logoB.png" alt="Logo" className="h-8 w-auto" />
                </Link>
                <div className="hidden sm:flex flex-col leading-tight text-white">
                    <span className="text-[10px] uppercase tracking-[0.15em] text-white/70">
                        Platform
                    </span>
                    <span className="text-sm font-semibold">
                        CargoSmart Control Center
                    </span>
                </div>
            </div>

            <div className="relative">
                <button
                    onClick={toggleProfileMenu}
                    className="flex items-center gap-2 px-2 py-1.5 rounded-xl bg-white/10 hover:bg-white/20 text-white transition-colors"
                >
                    <img
                        src={user?.imageProfile || '/images/usrAnonimo.png'}
                        alt="Profile"
                        className="w-9 h-9 rounded-full border border-white/30 object-cover"
                    />
                    <div className="hidden sm:flex flex-col items-start">
                        <p className="font-semibold text-xs">{user?.first_name || 'User'}</p>
                        <p className="text-[10px] text-white/70">{user?.role || 'Operator'}</p>
                    </div>
                    <i className={`fas fa-chevron-down text-white/70 text-[10px] ${isProfileMenuOpen ? 'rotate-180' : ''}`}></i>
                </button>

                {isProfileMenuOpen && (
                    <div className="absolute right-0 mt-2 w-44 bg-white border border-cs-border rounded-2xl shadow-xl text-xs overflow-hidden z-50">
                        <Link to="/profile" className="block px-3 py-2 hover:bg-cs-bg-alt text-cs-dark">
                            View profile
                        </Link>
                        <button
                            onClick={handleLogout}
                            className="block w-full text-left px-3 py-2 hover:bg-cs-bg-alt text-cs-danger"
                        >
                            Logout
                        </button>
                    </div>
                )}
            </div>
        </header>

    );
};

export default Header;
